import { transactionTypeMap } from "./utils";
import styles from ".././Component/AddBank/addbank.module.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Button } from "../Common";
import {formatText, formatDateAndTime} from "./utils";

const getStatusColor = (status) => {
  switch (status) {
    case "APPROVED":
      return "#4CAF50";
    case "REJECT":
      return "#F44336";
    case "PENDING":
      return "#FF9800";
    case "ONBOARDING":
      return "#2196F3";
    case "DISABLED":
      return "#757575";
    case "DELETED":
      return "#af1005";
    default:
      return "#fff";
  }
};
const countryCodeMap = {
  IN: "India",
  US: "United States of America",
  AU: "Australia",
  CA: "Canada",
  SG: "Singapore",
  FR: "France",
  DE: "Germany",
  IE: "Ireland",
  IT: "Italy",
  NL: "Netherlands",
  ES: "Spain",
  GB: "United Kingdom",
};

export const MCBUserColumn = (featureAccess) => {
  const { modifyAccess = false } = featureAccess || {};
  const columns = [
    { Header: "UserId", accessor: "userId" },
    { Header: "Username", accessor: "username" },
    { Header: "Name", accessor: "name" },
    { Header: "Email", accessor: "email" },
    { Header: "Phone No", accessor: "mobile" },
    {
      Header: "KYC Status",
      accessor: "status",
      Cell: (props) => {
        const { status, currentStep } = props.row.original;

        let displayStatus = status;

        if (
          [
            "REGISTER",
            "PERSONAL_INFO",
            "SIGNUP",
            "DOC_UPLOAD",
            "SELFIEE_UPLOAD",
          ].includes(currentStep)
        ) {
          displayStatus = "ONBOARDING";
        } else if (["SUBMIT", "SUBMITTED"].includes(currentStep)) {
          displayStatus = "PENDING";
        } else if (currentStep === "ACTIVE") {
          displayStatus = "APPROVED";
        }

        return (
          <span
            style={{
              color: getStatusColor(displayStatus),
              fontWeight: "500",
            }}
          >
            {formatText(displayStatus)}
          </span>
        );
      },
    },
    { Header: "Partner", accessor: "partnerName" },
    { Header: "Completed Step", accessor: "currentStep", formatText: true, },
    { Header: "Created At", accessor: "createdAt" },
  ];

  if (modifyAccess) {
    columns.push({
      Header: "Action",
      accessor: "closeAccount",
    });
  }

  return columns;
};

export const MCBBeneficiaryColumns = [
  {
    Header: "Name of Beneficiary",
    accessor: "nameOfBeni",
    search: false,
  },
  {
    Header: "Account Number",
    accessor: "maskAccountNo",
    search: false,
  },
  {
    Header: "Country",
    accessor: "country",
    search: false,
  },
  {
    Header: "Method",
    accessor: "method",
    search: false,
  },
  {
    Header: "Currency",
    accessor: "currency",
    search: false,
  },
  {
    Header: "Status",
    accessor: "status",
    search: false,
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    search: false,
  },
];

export const lienBeneficiaryColumns = (featureAccess) => {
  const { modifyAccess = false } = featureAccess || {};

  const columns = [
  {
    Header: "Name of Beneficiary",
    accessor: "nameOfBeni",
    search: false,
  },
  {
    Header: "Account Number",
    accessor: "maskAccountNo",
    search: false,
  },
  {
    Header: "Country",
    accessor: "country",
    search: false,
      Cell: ({ row }) => {
        const code = row.original.country;
        return <span>{countryCodeMap[code] || code || "--"}</span>;
      },
    },
    {
    Header: "Transfer Method",
    accessor: "method",
    search: false,
    Cell: ({ row }) => {
        const method = row.original.method;
        return (
          <span>
            {method === "LOCAL"
              ? "Borderless Instant"
              : method || "--"}
          </span>
        );
      },
  },
  // {
  //   Header: "Currency",
  //   accessor: "currency",
  //   search: false,
  // },
  {
    Header: "Status",
    accessor: "status",
    search: false,
      Cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            style={{
              color: getStatusColor(status),
              fontWeight: "600",
            }}
          >
            {status || "--"}
          </span>
        );
      },
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    search: false,
  },
  ];

  if (modifyAccess) {
    columns.push(
      {
        Header: "Transfer Money",
        accessor: "TransferNow",
      },
    );
  }
    if (modifyAccess) {
    columns.push(
      {
        Header: "Transfer Fee Config",
        accessor: "commissionConfig",
      },
    );
  }

  return columns;
};

export const MCBAddBeneficiaryColumns = [
  {
    Header: "First name",
    accessor: "firstName",
    search: false,
  },
  {
    Header: "Last Name",
    accessor: "lastName",
    search: false,
  },
  {
    Header: "Name of Bank",
    accessor: "bankName",
    search: false,
  },
  {
    Header: "Street Address",
    accessor: "streetAddress",
    search: false,
  },
  {
    Header: "Account Number",
    accessor: "accountNo",
    search: false,
  },
  {
    Header: "Account Routing Value",
    accessor: "accountRoutingValue",
    search: false,
  },
  {
    Header: "Swift Code",
    accessor: "swiftCode",
    search: false,
  },
  {
    Header: "City",
    accessor: "city",
    search: false,
  },
  {
    Header: "State",
    accessor: "state",
    search: false,
  },
  {
    Header: "Postcode",
    accessor: "postcode",
    search: false,
  },
  {
    Header: "Country",
    accessor: "country",
    search: false,
  },
  {
    Header: "Account Currency",
    accessor: "accountCurrency",
    search: false,
  },
];

export const MCBTransactionColumns = [
  {
    Header: "Transaction Number",
    accessor: "transaction_transaction_no",
    search: false,
  },
  {
    Header: "Transaction Type",
    accessor: "transaction_type",
    formatText: true,
    search: false,
  },
  {
    Header: "From Account Name",
    accessor: "from_account_user_name",
    search: false,
    Cell: ({ row }) => {
      const {
        transaction_type,
        transaction_from_account_desc,
        from_account_user_name,
      } = row.original;

      if (["FUND_RECEIVED", "FUND_RECEIVED_LIEN"].includes(transaction_type)) {
        return transaction_from_account_desc
          ? `${transaction_from_account_desc} (ext)`
          : "-";
      }
       if (transaction_type === "REFUND") {
      return transaction_from_account_desc || "-";
    }
      return from_account_user_name || "-";
    },
  },
  {
    Header: "To Account Name",
    accessor: "to_account_user_name",
    search: false,
     Cell: ({ row }) => {
      const {
        transaction_type,
        transaction_to_account_desc,
        to_account_user_name,
      } = row.original;

      if (transaction_type === "CHARGE") {
        return transaction_to_account_desc
          ? transaction_to_account_desc
          : "-";
      }
      return to_account_user_name || "-";
    },
  },
  {
    Header: "Amount",
    accessor: "transaction_amount",
    search: false,
  },
  {
    Header: "Status",
    accessor: "transaction_status",
    search: false,
  },
  {
    Header: "Created At",
    accessor: "transaction_created_at",
    search: false,
  },
  {
    Header: "View Details",
    accessor: "details",
    search: false,
  },
];
export const MCBLienTransactionColumns = [
  {
    Header: "Transaction Number",
    accessor: "transaction_transaction_no",
    search: false,
  },
  {
    Header: "Transaction Type",
    accessor: "transaction_type",
    formatText: true,
    search: false,
  },
  {
    Header: "To Account Name",
    accessor: "to_account_user_name",
    search: false,
  },
  {
    Header: "Amount",
    accessor: "transaction_amount",
    search: false,
  },
  {
    Header: "Status",
    accessor: "transaction_status",
    search: false,
  },
  {
    Header: "Created At",
    accessor: "transaction_created_at",
    search: false,
  },
  {
    Header: "View Details",
    accessor: "details",
    search: false,
  },
];

export const InvestingReportColumns = [
  {
    Header: "Customer Id.",
    accessor: "custId",
    search: false,
  },
  {
    Header: "Transaction Date",
    accessor: "tranWhen",
    search: false,
    sort: "ASC",
  },
  {
    Header: "Order ID",
    accessor: "orderID",
    Cell: ({ row }) => {
      return row.original.orderID === "0" || !row.original.orderID
        ? "--"
        : row.original.orderID;
    },
    search: false,
    sort: "ASC",
  },
  {
    Header: "Transaction Type",
    accessor: "finTranTypeID",
    Cell: ({ row }) => {
      return row.original.finTranTypeID
        ? transactionTypeMap[row.original.finTranTypeID] ||
        row.original.finTranTypeID
        : "--";
    },
    search: false,
  },
  {
    Header: "Amount",
    accessor: "accountAmount",
    search: false,
  },
  {
    Header: "Balance",
    accessor: "accountBalance",
    search: false,
  },
  {
    Header: "Comments",
    accessor: "comment",
    search: false,
  },
];

export const UserReportColumns = [
  {
    Header: "Start",
    accessor: "fromDt",
    search: false,
  },
  {
    Header: "End",
    accessor: "toDt",
    search: false,
  },
  {
    Header: "Status",
    accessor: "status",
    search: false,
  },
  {
    Header: "Partner",
    accessor: "partnerCd",
    search: false,
  },
  {
    Header: "Report Type",
    accessor: "filterType",
    search: false,
    formatText: true,
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    search: false,
  },
  {
    Header: "Download",
    accessor: "path",
    search: false,
  }
];

export const followUpColumns = (featureAccess = {}) => {
  const {
    modifyAccess = false,
    writeAccess = false,
  } = featureAccess;

  const columns = [
    {
      Header: "Subject",
      accessor: "subject",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Priority",
      accessor: "priority",
    },
    {
      Header: "Status",
      accessor: "status",
      formatText: true,
    },
    {
      Header: "View History",
      accessor: "details",
    },
  ];

  if (modifyAccess || writeAccess) {
    columns.push({
      Header: "Actions",
      accessor: "actions",
      modifyAccess,
      writeAccess,
    });
  }

  return columns;
};



export const partnerColumns = (featureAccess) => {
  const {
    modifyAccess = false
  } = featureAccess || {};

  const columns = [
    {
      Header: "Partner Name",
      accessor: "name",
    },
    {
      Header: "Partner Code",
      accessor: "code",
    },
    {
      Header: "Partner Location",
      accessor: "location",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Created At",
      accessor: "createdAt",
    },
    {
      Header: "View Details",
      accessor: "details",
    },
  ];

  if (modifyAccess) {
    columns.push(
      {
        Header: "Actions",
        accessor: "partnerAction",
      },
      {
        Header: "Add Config",
        accessor: "addConfig",
      }
    );
  }

  return columns;
};


export const bankColumns = (
  decryptedAccounts,
  loadingAccounts,
  handleToggleAccountVisibility,
  featureAccess
) => {
  const { modifyAccess = false, writeAccess = false } = featureAccess || {};

  const columns = [
    {
      Header: "Beneficiary Name",
      accessor: "beneficiaryName",
    },
    {
      Header: "Account Number",
      accessor: "accountNumber",
      Cell: ({ row }) => {
        const item = row.original;
        const isDecrypted = decryptedAccounts[item.stoUserBankId];
        const isLoading = loadingAccounts[item.stoUserBankId];

        return (
          <div className={styles.accountNumberColumn}>
            <span className={styles.accountNumber}>
              {isDecrypted ? decryptedAccounts[item.stoUserBankId] : item.accountNumber}
            </span>

            {writeAccess && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleToggleAccountVisibility(item);
                }}
                className={styles.accountButton}
                disabled={isLoading}
                title={isDecrypted ? "Hide account number" : "Show account number"}
              >
                {isLoading ? (
                  <div className={styles.accountLoader} />
                ) : isDecrypted ? (
                  <AiOutlineEyeInvisible size={16} />
                ) : (
                  <AiOutlineEye size={16} />
                )}
              </button>
            )}
          </div>
        );
      }
    },
    {
      Header: "IFSC",
      accessor: "bankIFSC",
    },
    {
      Header: "Account Type",
      accessor: "beneficiaryAccountType",
    },
    {
      Header: "Swift ABA",
      accessor: "beneficiarySwiftABA",
    },
    {
      Header: "Bank Name",
      accessor: "bankName",
    },
  ];

  if (modifyAccess) {
    columns.push({
      Header: "Delete Account",
      accessor: "bankAccountDelete",
    });
  }

  return columns;
};


export const planColumns = (featureAccess) => {
  const {
    modifyAccess = false
  } = featureAccess || {};

  const columns = [

    {
      Header: "Plan Name",
      accessor: "name",
    },
    {
      Header: "Plan Code",
      accessor: "code",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Subscription Amount",
      accessor: "subscriptionAmt",
    },
    {
      Header: "Account Open Fees",
      accessor: "acctOpenFeesAmt",
    },
    {
      Header: "Currency",
      accessor: "currencyCd",
    },
    {
      Header: "Created At",
      accessor: "createdAt",
    },
    {
      Header: "View Details",
      accessor: "details",
    },
  ];
  if (modifyAccess) {
    columns.push(
      {
        Header: "Actions",
        accessor: "editPlan",
      },
      {
        Header: "Add Config",
        accessor: "addConfig",
      },
    );
  }

  return columns;
};
export const EventColumns = [
  {
    Header: "Application name",
    accessor: "applicationName",
    search: false,
  },
  {
    Header: "Start Time",
    accessor: "startTime",
    search: false,
  },
  {
    Header: "End Time",
    accessor: "endTime",
    search: false,
  },
  {
    Header: "message",
    accessor: "message",
    search: false,
  },
];


export const InvCouponsColumns = (featureAccess) => {
  const {
    modifyAccess = false
  } = featureAccess || {};

  const columns = [

    {
      Header: "Coupon Title",
      accessor: "title",
      search: false,
    },
    {
      Header: "Coupon Code",
      accessor: "code",
      search: false,
    },
    {
      Header: "Discount Type",
      accessor: "discounttype",
      search: false,
    },
    {
      Header: "Discount Value",
      accessor: "discountvalue",
      search: false,
    },
    {
      Header: "Status",
      accessor: "status",
      search: false,
    },
    {
      Header: "Created At",
      accessor: "createdat",
      search: false,
    },
    {
      Header: "View Details",
      accessor: "details",
    },
  ];
  if (modifyAccess) {
    columns.push(
      {
        Header: "Edit Coupon",
        accessor: "editCoupon",
      },
    );
  }

  return columns;
};

export const TRANSACTION_NATURE = {
  FUND_RECEIVED: "CREDIT",
  REFUND: "CREDIT",
  REVERSAL: "CREDIT",
  CLEARING: "DEBIT",
  FEES: "DEBIT",
  FUND_TRANSFER: "CREDIT",
  FUND_TRANSFER_LIEN: "CREDIT",
  TRANSFER: "DEBIT",
  CHARGE: "DEBIT",
  AUTHORIZATION: "DEBIT",
  CONVERSION: "BOTH",
  FUND_RECEIVED_LIEN: "CREDIT",
};

export const transactionColumns = [
  {
    Header: "Transaction Number",
    accessor: "transaction_transaction_no",
    search: false,
  },
  {
    Header: "Transaction Type",
    accessor: "transaction_type",
    formatText: true,
    search: false,
  },
  {
    Header: "Account Type",
    search: false,
    Cell: ({ row }) => {
      const {
        from_account_account_type,
        to_account_account_type,
        card_from_account_account_type,
      } = row.original;

      return (
        from_account_account_type ||
        to_account_account_type ||
        card_from_account_account_type ||
        "-"
      );
    },
  },
  {
    Header: "From Account Name",
    accessor: "from_account_user_name",
    search: false,
    Cell: ({ row }) => {
      const {
        transaction_type,
        transaction_from_account_desc,
        from_account_user_name,
      } = row.original;

      if (["FUND_RECEIVED", "FUND_RECEIVED_LIEN"].includes(transaction_type)) {
        return transaction_from_account_desc
          ? `${transaction_from_account_desc} (ext)`
          : "-";
      }
       if (transaction_type === "REFUND") {
      return transaction_from_account_desc || "-";
    }
      return from_account_user_name || "-";
    },
  },
  {
    Header: "To Account Name",
    accessor: "to_account_user_name",
    search: false,
     Cell: ({ row }) => {
      const {
        transaction_type,
        transaction_to_account_desc,
        to_account_user_name,
      } = row.original;

      if (transaction_type === "CHARGE") {
        return transaction_to_account_desc
          ? transaction_to_account_desc
          : "-";
      }
      return to_account_user_name || "-";
    },
  },
  {
    Header: "Amount Debited",
    search: false,
    Cell: ({ row }) => {
      const data = row.original;
      const nature = TRANSACTION_NATURE[data.transaction_type];

      if (nature !== "DEBIT" && nature !== "BOTH") return "-";

      const amount =
        data.transaction_debit_amount ?? data.transaction_amount;

      if (!amount || amount === 0) return "-";

      return `${amount} ${data.transaction_from_currency || ""}`;
    },
  },
  {
    Header: "Amount Credited",
    search: false,
    Cell: ({ row }) => {
      const data = row.original;
      const nature = TRANSACTION_NATURE[data.transaction_type];

      if (nature !== "CREDIT" && nature !== "BOTH") return "-";

      const amount = data.transaction_amount;

      if (!amount || amount === 0) return "-";

      return `${amount} ${data.transaction_to_currency || ""}`;
    },
  },
  {
    Header: "Status",
    accessor: "transaction_status",
    search: false,
  },
  {
    Header: "Created At",
    accessor: "transaction_created_at",
    search: false,
  },
   {
    Header: "View Details",
    accessor: "details",
    search: false,
  },
];


export const partnerRatesColumns = (featureAccess) =>{
  const {
    modifyAccess = false
  } = featureAccess || {};

  const columns = [

  {
    Header: "Currency Group",
    accessor: "currencyGroup",
    formatText: true,
    search: false,
  },
  {
    Header: "Currencies",
    accessor: "currencies",
    search: false,
  },
  {
    Header: "Vendor Markup (%)",
    accessor: "vendorMarkup",
    search: false,
  },
  {
    Header: "Desired Markup (%)",
    accessor: "desiredMarkup",
    search: false,
  },
  {
    Header: "Stockal Markup (%)",
    accessor: "stockalMarkup",
    search: false,
  },
];
  if (modifyAccess) {
    columns.push(
  {
    Header: "Edit stockal Markup",
    accessor: "editPartnerRates",
  },  
);
  }

  return columns;
};

  export const MCBPartnerBeneficiaryColumns = (
  featureAccess
) => {
  const { modifyAccess = false, writeAccess = false } = featureAccess || {};

  const columns = [
  {
    Header: "Name of Beneficiary",
    accessor: "nameOfBeni",
    search: false,
  },
  {
    Header: "Account Number",
    accessor: "maskAccountNo",
    search: false,
  },
  {
    Header: "Country",
    accessor: "country",
    search: false,
  },
  {
    Header: "Status",
    accessor: "status",
    search: false,
      Cell: ({ row }) => {
        const status = row.original.status;
        return (
          <span
            style={{
              color: getStatusColor(status),
              fontWeight: "600",
            }}
          >
            {status || "--"}
          </span>
        );
      },
  },
  {
    Header: "Partner",
    accessor: "partnerName",
    search: false,
  },
  {
    Header: "Bank Name",
    accessor: "bankName",
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    search: false,
  },
];
  if (modifyAccess) {
    columns.push({
      Header: "Delete Beneficiary",
      accessor: "beneficiaryDelete",
    });
  }

  return columns;
};

const orDash = (accessor) => ({ row }) => row.original[accessor] || "--";

export const MCBBeneficiaryListColumns = [
  { Header: "Name", accessor: "name", search: false, Cell: orDash("name") },
  { Header: "Phone Number", accessor: "phone", search: false, Cell: orDash("phone") },
  { Header: "Email", accessor: "email", search: false, Cell: orDash("email") },
  { Header: "Name of Beneficiary", accessor: "nameOfBeni", search: false, Cell: orDash("nameOfBeni") },
  { Header: "Country", accessor: "country", search: false, Cell: orDash("country") },
  { Header: "Currency", accessor: "currency", search: false, Cell: orDash("currency") },
  {
    Header: "Created At",
    accessor: "createdAt",
    search: false,
    Cell: ({ row }) => formatDateAndTime(row.original.createdAt),
  },
];

export const MCBPartnerAddBeneficiaryColumns = [
  {
    Header: "First Name",
    accessor: "firstName",
    search: false,
  },
  {
    Header: "Last Name",
    accessor: "lastName",
    search: false,
  },
  {
    Header: "Name of Bank",
    accessor: "bankName",
    search: false,
  },
  {
    Header: "Street Address",
    accessor: "streetAddress",
    search: false,
  },
  {
    Header: "Account Number",
    accessor: "maskAccountNo",
    search: false,
  },
  {
    Header: "Swift Code",
    accessor: "swiftCode",
    search: false,
  },
  {
    Header: "City",
    accessor: "city",
    search: false,
  },
  {
    Header: "State",
    accessor: "state",
    search: false,
  },
  {
    Header: "Postcode",
    accessor: "postcode",
    search: false,
  },
  {
    Header: "Country",
    accessor: "country",
    search: false,
  },
  {
    Header: "Status",
    accessor: "status",
    search: false,
  },
];
